const DANGEROUS_TAGS = ['script', 'iframe', 'object', 'embed', 'link', 'meta'];
const RICH_TEXT_TAG_PATTERN = /<\s*\/?\s*(?:a|b|blockquote|br|div|em|font|h[1-6]|hr|i|img|li|ol|p|span|strong|table|tbody|td|th|thead|tr|u|ul)\b[^>]*>/i;

function cleanInlineStyle(value = '') {
  return value
    .split(';')
    .map((rule) => rule.trim())
    .filter(Boolean)
    .filter((rule) => !rule.toLowerCase().startsWith('font-family'))
    .join('; ');
}

export function sanitizeMessageHtml(html = '') {
  if (!html) {
    return '';
  }

  if (typeof window === 'undefined' || typeof window.DOMParser === 'undefined') {
    return html;
  }

  const parser = new window.DOMParser();
  const parsed = parser.parseFromString(html, 'text/html');

  DANGEROUS_TAGS.forEach((tag) => {
    parsed.querySelectorAll(tag).forEach((node) => node.remove());
  });

  parsed.querySelectorAll('*').forEach((element) => {
    Array.from(element.attributes).forEach((attribute) => {
      const attrName = attribute.name.toLowerCase();

      if (attrName.startsWith('on')) {
        element.removeAttribute(attribute.name);
        return;
      }

      if (attrName === 'style') {
        const sanitizedStyle = cleanInlineStyle(attribute.value);

        if (sanitizedStyle) {
          element.setAttribute('style', sanitizedStyle);
        } else {
          element.removeAttribute('style');
        }
      }
    });
  });

  return parsed.body.innerHTML;
}

export function isRichTextMessage(content = '') {
  return typeof content === 'string' && RICH_TEXT_TAG_PATTERN.test(content);
}
